module.exports = __webpack_public_path__ + "img/7.8e861e7c.jpg";